export const AppUserRoles = {
    ADMINISTRATOR : 1,
    USER : 2,
    getAllRoleIds : () => {
        return [
            AppUserRoles.ADMINISTRATOR,
            AppUserRoles.USER
        ]
    }
}